import axios from "axios";
const Sentry =
  typeof window === "undefined"
    ? require("@sentry/node")
    : require("@sentry/browser");

const wpAxios = () => {
  const newAxios = axios;

  newAxios.interceptors.request.use(
    function (config) {
      // Ghi breadcrumb để theo dõi các request
      Sentry.addBreadcrumb({
        category: "axios",
        message: `Request to ${config.url}`,
        level: "info",
        data: {
          method: config.method,
          data: config.data,
          headers: config.headers,
        },
      });
      return config;
    },
    function (error) {
      // Ghi lỗi xảy ra trước khi request được gửi
      Sentry.captureException(error, {
        tags: { type: "axios-request" },
        extra: {
          config: error?.config,
          message: error.message,
        },
      });
      return Promise.reject(error);
    }
  );

  newAxios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      // Ghi lỗi từ response (ví dụ lỗi 404, 500...)
      Sentry.captureException(error, {
        tags: { type: "axios-response" },
        extra: {
          url: error?.config?.url,
          method: error?.config?.method,
          requestData: error?.config?.data,
          status: error?.response?.status,
          responseData: error?.response?.data,
        },
      });
      return Promise.reject(error);
    }
  );

  return newAxios;
};

export default wpAxios;
